import { useState, useMemo } from "react";
import { LargeButton } from "@/components/pages/home/_00Global/LargeButton";

export const DateChecker = (): JSX.Element => {
  // Calculate minimum date (5 days from today)
  const minDate = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() + 5);
    return date.toISOString().split('T')[0];
  }, []);

  const [selectedDate, setSelectedDate] = useState<string>(minDate);
  const [isChecking, setIsChecking] = useState(false);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);
  const [dateError, setDateError] = useState<string>("");

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    setSelectedDate(selectedValue);
    setDateError("");
    setIsAvailable(null);

    // Validate the selected date
    const selectedTimestamp = new Date(selectedValue).getTime();
    const minTimestamp = new Date(minDate).getTime();
    
    if (selectedTimestamp < minTimestamp) {
      setDateError("Please select a date at least 5 days from today");
      return;
    }
  };

  const handleDateCheck = () => {
    if (!selectedDate) return;
    
    setIsChecking(true);
    // Simulate checking process
    setTimeout(() => {
      setIsChecking(false);
      setIsAvailable(true); // For demo, always show as available
    }, 3000);
  };

  const handleZoomConsultation = () => {
    console.log("Booking Zoom consultation");
    // Add Zoom booking logic
  };

  const handleBookNow = () => {
    console.log("Booking now");
    // Add booking logic
  };

  const handleWhatsApp = () => {
    window.open('https://api.whatsapp.com/send?phone=447462294653', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex flex-col items-center w-full max-w-[800px] mx-auto px-8 pb-5">
      {/* Title */}
      <h1 className="[font-family:var(--contact-cardtitle-font-family)] [font-size:var(--contact-cardtitle-font-size)] text-[var(--fy-grey)] text-center mb-[50px]">
        Check Your Date
      </h1>

      {/* Date Picker Section */}
      <div className="flex flex-col items-center space-y-[50px] w-full max-w-md mb-[50px]">
        <div className="w-full">
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            min={minDate}
            className="w-full p-4 text-lg border border-[var(--fy-greyish)] rounded-lg focus:outline-none focus:border-[var(--fy-grey)] bg-white text-[var(--fy-grey)]"
          />
          {dateError && (
            <p className="mt-2 text-red-500 text-sm">
              {dateError}
            </p>
          )}
        </div>
        <LargeButton 
          text="CHECK AVAILABILITY" 
          onClick={handleDateCheck}
          disabled={!selectedDate || isChecking || !!dateError}
        />
      </div>

      {/* Checking Status */}
      {isChecking && (
        <div className="flex flex-col items-center space-y-[50px] mb-[50px]">
          <div className="w-8 h-8 border-4 border-[var(--fy-grey)] border-t-transparent rounded-full animate-spin"></div>
          <p className="text-[var(--fy-grey)] text-lg">
            Checking availability for your special day...
          </p>
        </div>
      )}

      {/* Result Section */}
      {isAvailable && !isChecking && (
        <div className="flex flex-col items-center w-full">
          <div className="text-center space-y-[50px] mb-[50px]">
            <h2 className="[font-family:var(--contact-cardtitle-font-family)] text-2xl text-[var(--fy-grey)]">
              Congratulations!
            </h2>
            <p className="text-[var(--fy-grey)]">
              Your date ({selectedDate}) is available!
            </p>
          </div>
          
          <div className="flex flex-col w-full max-w-md space-y-[50px]">
            <LargeButton 
              text="BOOK ZOOM CONSULTATION" 
              onClick={handleZoomConsultation}
            />
            <LargeButton 
              text="BOOK NOW ONLINE" 
              onClick={handleBookNow}
            />
            <LargeButton 
              text="WHATSAPP US NOW" 
              onClick={handleWhatsApp}
            />
          </div>
        </div>
      )}
    </div>
  );
}; 